import type { IDemo } from '@carboncopyco/types';
import constate from 'constate';

export type TeamActivityPageProps = {
  goToDemoPageByWorkspace: (
    demoId: IDemo['id'],
    workspaceId: string,
    tab?: string
  ) => void;
  goToClonePageByWorkspace: (
    id: any,
    workspaceId: string,
    tab?: string
  ) => void;
  goToPresentationPageFromHomepage: (
    id: any,
    workspaceId: any,
    tab?: string
  ) => void;
};

export type TeamActivityPageState = TeamActivityPageProps;

const useTeamActivity = (props: TeamActivityPageState): TeamActivityPageState =>
  props;

export const [TeamActivityProvider, useTeamActivityProps] =
  constate(useTeamActivity);
